import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useCallback,
} from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import debounce from "lodash.debounce";

import { makeStyles } from "@mui/styles";
import {
  Grid,
  Dialog,
  DialogContent,
  Box,
  Alert,
  List,
  ListItem,
  ListItemText,
  Divider,
  Radio,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  FormControl,
  TextField,
} from "@mui/material";
import axios from "axios";
import Moment from "moment";

import typeCard from "assets/img/marcas-tarjetas.png";
import errorImg from "assets/img/error.png";
import successImg from "assets/img/success.gif";
import loaderGif from "assets/img/loading.gif";
import pendingImg from "assets/img/pending.png";

import {
  cardBodyStyle,
  ButtonStyle0,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function ClientPayment(props) {
  const classes = useStyles();

  //const [iframeUrl, setIframeUrl] = useState("");
  const [info, setInfo] = useState(true);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [radioDocument, setRadioDocument] = React.useState("CI");
  const [loader, setLoader] = useState(false);
  const [valueRadio, setValueRadio] = React.useState("titular");
  const [disabledPay, setDisabledPay] = React.useState(false);
  const [alert, setAlert] = useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
    img: "",
  });

  const { urlServices, LightboxPlaceToPay } = useContext(UrlServicesContext);

  const [values, setValues] = useState({
    allName: "",
    documentIdClient: "",
    documentId: "",
    emailFact: "",
    addressFact: "",
    errorAllName: false,
    errorDocumentId: false,
    errorEmailFact: false,
    errorAddressFact: false,
  });

  const handleChange = useCallback((prop, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [prop]: value,
    }));

    // Solo usar debounce para realizar validaciones u otros efectos secundarios
    debounceValidation(prop, value);
  }, []);

  const debounceValidation = useCallback(
    debounce((prop, value) => {
      setValues((prevValues) => ({
        ...prevValues,
        errorAllName: false,
        errorDocumentId: false,
        errorEmailFact: false,
        errorAddressFact: false,
      }));

      setAlert((prevAlert) => ({
        ...prevAlert,
        openAlert: false,
      }));
    }, 10),
    []
  );

  // Cargar el script del Lightbox en el componente
  useEffect(() => {
    const script = document.createElement("script");
    script.src = LightboxPlaceToPay;
    script.async = true;
    document.body.appendChild(script);

    // Limpiar el script al desmontar el componente
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const createPay = () => {
    setError(false);

    if (valueRadio === "otro") {
      const validations = {
        allName: {
          value: values.allName,
          message: "Agregue Nombre completo para los datos de facturación.",
        },
        documentId: {
          value: values.documentId,
          message: "Agregue un Documento para los datos de facturación.",
        },
        emailFact: {
          value: values.emailFact,
          message:
            "Agregue un correo electrónico para los datos de facturación.",
        },
        addressFact: {
          value: values.addressFact,
          message: "Agregue una dirección para los datos de facturación.",
        },
      };

      for (const [key, { value, message }] of Object.entries(validations)) {
        if (value.length === 0) {
          setValues((prev) => ({
            ...prev,
            [`error${key.charAt(0).toUpperCase() + key.slice(1)}`]: true,
          }));
          setAlert({
            openAlert: true,
            errorAlert: "error",
            mensaje: message,
          });

          return; // Salir si hay un error
        }
      }

      sendData();
    } else {
      sendData();
    }
  };

  const sendData = () => {
    setDisabledPay(true);

    const dataValue = {
      document: props.rows.client.documentId,
      documentType: props.rows.client.typeDocument,
      name: props.rows.client.name1,
      surname: props.rows.client.lastName1,
      email: props.rows.client.email,
      mobile: `+${props.rows.client.prefix.prefix}${props.rows.client.phone}`,
      subTotal: props.rows.productsJson[0].subTotal,
      ivaTotal: props.rows.productsJson[0].ivaTotal,
      payTotal: props.rows.productsJson[0].payTotal,
      clientsTransactionId: props.rows.id,
    };

    axios
      .post(`${urlServices}placetopay/create-pay`, dataValue)
      .then((response) => {
        openLightbox(response.data);
        // window.open(response.data.data.processUrl, "_blank");
      })
      .catch((error) => {
        setDisabledPay(false);
        handleError(error);
      });
  };

  // Manejo común de errores
  const handleError = (error) => {
    if (error.response?.status === 404) {
      setMensageSystem("Registro no encontrado.");
      setError(true);
    } else if (error.response?.status === 500) {
      setMensageSystem("Error en la consulta con el servidor.");
      setError(true);
    } else {
      console.error("Error en la solicitud:", error);
      setMensageSystem("Error al realizar la solicitud.");
      setError(true);
    }
    setLoader(false);
  };

  // Función para abrir el Lightbox
  const openLightbox = (valuesData) => {
    if (window.P) {
      /* window.P.on("close", function () {
        alert("El usuario cerró el Lightbox");
      });*/

      window.P.on("response", function (response) {
        // console.log("Respuesta de Lightbox:", response);
        submitRequestPay(valuesData.paymentTransaction);
      });

      // Iniciar el Lightbox
      window.P.init(valuesData.data.processUrl);
    }
  };

  const submitRequestPay = async (paymentTransaction) => {
    try {
      setInfo(false);
      setLoader(true);

      const response = await axios.post(
        `${urlServices}placetopay/view-pay/${paymentTransaction.requestIdTransaction}`
      );
      if (response.status === 201) {
        const status = response.data.data.status;
        if (status.status === "REJECTED") {
          setAlert({
            openAlert: true,
            errorAlert: "error",
            mensaje: "Tu pago fue RECHAZADO",
            reference: response.data.data.request.payment.reference,
            date: Moment(response.data.data.status.date).format("DD-MM-YYYY"),
            price: response.data.data.request.payment.amount.total,
            receipt: null,
            img: errorImg,
          });
        } else if (status.status === "APPROVED") {
          setAlert({
            openAlert: true,
            errorAlert: "success",
            mensaje: "Tu pago ha sido APROBADO y registrado exitosamente",
            reference: response.data.data.request.payment.reference,
            date: Moment(response.data.data.status.date).format("DD-MM-YYYY"),
            price: response.data.data.request.payment.amount.total,
            receipt: response.data.data.payment[0].receipt,
            img: successImg,
          });
        } else if (status.status === "PENDING") {
          setAlert({
            openAlert: true,
            errorAlert: "warning",
            mensaje: "Tu pago está en estado PENDIENTE",
            reference: response.data.data.request.payment.reference,
            date: Moment(response.data.data.status.date).format("DD-MM-YYYY"),
            price: response.data.data.request.payment.amount.total,
            receipt: null,
            img: pendingImg,
          });
        }
        submitSave(paymentTransaction.id, response.data.data);
      }
    } catch (error) {
      handleError(error);
    }
  };

  const submitSave = async (id, data) => {
    const dataValue = {
      responseTransaction: JSON.stringify(data),
      status:
        data.status.status === "APPROVED"
          ? 1
          : data.status.status === "REJECTED"
          ? 0
          : 3,
    };

    try {
      const response = await axios.put(
        `${urlServices}payment-transaction/${id}`,
        dataValue
      );
      if (response.status === 200) {
        setLoader(false);
        if (data.status.status === "APPROVED") {
          sendCert(data);
        } else {
          sendEmailInfoError(data);
        }
      }
    } catch (error) {
      handleError(error); // Usa el mismo manejador de errores aquí
    }
  };

  const sendCert = async (data) => {
    let dataNewFacturacion = null;

    if (valueRadio === "otro") {
      dataNewFacturacion = {
        allNames: values.allName,
        documentId: values.documentId,
        documentTipo: values.documentIdClient,
        email: values.emailFact,
        direccion: values.addressFact,
      };
    }

    // Crear una copia de props.rows para evitar mutaciones directas de los props
    const updatedRows = { ...props.rows };

    if (updatedRows.client) {
      updatedRows.client.newDataClient = dataNewFacturacion;
    }

    const dataValue = {
      dataTransaction: updatedRows,
      paytransaction: data,
    };

    try {
      const response = await axios.post(
        `${urlServices}payment-transaction/create`,
        dataValue
      );
      if (response.status === 200) {
      }
    } catch (error) {
      handleError(error); // Usa el mismo manejador de errores aquí
    }
  };

  const sendEmailInfoError = async (data) => {
    let dataNewFacturacion = null;

    if (valueRadio === "otro") {
      dataNewFacturacion = {
        allNames: values.allName,
        documentId: values.documentId,
        documentTipo: values.documentIdClient,
        email: values.emailFact,
        direccion: values.addressFact,
      };
    }

    // Crear una copia de props.rows para evitar mutaciones directas de los props
    const updatedRows = { ...props.rows };

    if (updatedRows.client) {
      updatedRows.client.newDataClient = dataNewFacturacion;
    }

    const dataValue = {
      dataTransaction: updatedRows,
      paytransaction: data,
    };

    try {
      const response = await axios.post(
        `${urlServices}payment-transaction/email-info-error`,
        dataValue
      );
      if (response.status === 200) {
      }
    } catch (error) {
      handleError(error); // Usa el mismo manejador de errores aquí
    }
  };

  /*const validateTransaction = (paymentTransaction) => {
    setLoader(true)
    // Función para validar la transacción periódicamente
  //  const interval = setInterval(() => {
      axios
        .post(`${urlServices}placetopay/view-pay/${paymentTransaction.requestIdTransaction}`) // Consulta el estado de la transacción
        .then((response) => {
          setDisabled(true)
          const status = response.data.data.status.status;
          console.log("Estado de la transacción:", status);

          // Si la transacción fue aprobada o fallida, detén la consulta
          if (
            status === "APPROVED" ||
            status === "REJECTED"
          ) {
            setLoader(false)
       //     clearInterval(interval); // Detener el intervalo
         //   setIntervalId(null); // Limpiar el ID del intervalo
            // Lógica para manejar los diferentes estados
            if (status === "APPROVED") {
              setMensageSystem("Pago aprobado!");
            } else if (status === "REJECTED") {
              setMensageSystem("Pago rechazado.");
            } else {
              setMensageSystem("La transacción expiró.");
            }
            setError(false);
          }
        })
        .catch((error) => {
          setDisabled(false)
          handleError(error);
      //    clearInterval(interval); // Detener el intervalo en caso de error
      //    setIntervalId(null); // Limpiar el ID del intervalo
          setLoader(false)
        });
  //  }, 3000); // Ejecutar cada 1 segundo

   // setIntervalId(interval); // Guardar el ID del intervalo en el estado
  };*/

  /*const handleCloseDialog = () => {
    props.exit();
       if (intervalId) {
       clearInterval(intervalId); // Detener el intervalo cuando el diálogo se cierra
      }
  };*/

  const style = {
    py: 0,
    width: "100%",
    maxWidth: 360,
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    backgroundColor: "background.paper",
  };

  const handleChangeRadio = (event) => {
    setValues({
      ...values,
      allName: "",
      documentId: "",
      errorAllName: false,
      errorDocumentId: false,
    });
    setValueRadio(event.target.value);
  };

  const handleRadioDocument = (event) => {
    setValues({ ...values, documentIdClient: "" });
    setRadioDocument(event.target.value);
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="md"
        //onClose={handleCloseDialog}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Grid
            container
            spacing={2}
            className={classes.containerProfile}
            sx={{ paddingBottom: 8 }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              sx={{ textAlign: "left", display: info ? "block" : "none" }}
            >
              <div className={classes.titleCardFilter}>Realizar el pago</div>
              <div className={classes.lineBottom}></div>
            </Grid>
            <Grid item xs={12}>
              {error && <Alert severity="error">{mensageSystem}</Alert>}
            </Grid>
            {info ? (
              <>
                <Grid item xs={12} sm={12} sx={{ fontSize: 16 }}>
                  <b>Cliente titular: </b> {props.rows.client.allNames}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      sx={{
                        background: "lavender",
                        borderRadius: 5,
                        mt: 1,
                        p: "18px 25px",
                        fontSize: 14,
                      }}
                    >
                      <b>Producto: </b> {props.rows.productsJson[0].name}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      sx={{ p: "15px 0 0 60px", fontSize: 12 }}
                    >
                      <b style={{ marginRight: 10 }}>
                        SUBTOTAL {props.rows.productsJson[0].iva}%:{" "}
                      </b>
                      $
                      {props.rows.productsJson[0].selectIVA === 0
                        ? "0.00"
                        : props.rows.productsJson[0].subTotal}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      sx={{ p: "3px 0 0 60px", fontSize: 12 }}
                    >
                      <b style={{ marginRight: 10 }}>SUBTOTAL 0%: </b> $
                      {props.rows.productsJson[0].selectIVA === 1
                        ? "0.00"
                        : props.rows.productsJson[0].subTotal}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      sx={{ p: "3px 0 0 60px", fontSize: 12 }}
                    >
                      <b style={{ marginRight: 10 }}>
                        IVA {props.rows.productsJson[0].iva}%:{" "}
                      </b>
                      $
                      {props.rows.productsJson[0].selectIVA === 0
                        ? "0.00"
                        : props.rows.productsJson[0].ivaTotal}
                    </Grid>
                    {/*<Grid
                      item
                      xs={12}
                      sm={12}
                      sx={{ p: "3px 0 0 60px", fontSize: 12 }}
                    >
                      <b style={{ marginRight: 10 }}>Período: </b>
                      {props.rows.productsJson[0].periodo}
                    </Grid>*/}
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      // sx={{ p: "10px 0 0 60px", fontSize: 12 }}
                      sx={{
                        background: "lavender",
                        borderRadius: 5,
                        mt: 1,
                        p: "10px 15px",
                        fontSize: 12,
                        textAlign: "center",
                      }}
                    >
                      <b>TOTAL: </b> ${props.rows.productsJson[0].payTotal}
                    </Grid>
                    {valueRadio === "otro" && (
                      <>
                        <Grid item xs={12} sm={6}>
                          <center>
                            <Box
                              component="img"
                              src="https://static.placetopay.com/placetopay-logo.svg"
                              alt="paymentsCompany"
                              sx={{
                                width: 140,
                                m: { xs: "5% 0", sm: "20% 0" },
                              }}
                            ></Box>
                          </center>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <center>
                            <Box
                              component="img"
                              src={typeCard}
                              alt="franquicias"
                              sx={{
                                width: 170,
                                m: { xs: "2% 0", sm: "17% 0" },
                              }}
                            ></Box>
                          </center>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              </>
            ) : loader ? (
              <Grid item xs={12} sm={12}>
                <center>
                  <img
                    alt="loaderGif"
                    src={loaderGif}
                    style={{ width: 60, margin: "20% 0" }}
                  />
                </center>
              </Grid>
            ) : (
              <>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={alert.img}
                    alt="type"
                    style={{ width: 150, marginBottom: 20 }}
                  />
                  <Alert
                    severity={
                      alert.errorAlert === "success" ? "success" : "error"
                    }
                    icon={false}
                    sx={{ fontSize: 20 }}
                  >
                    {alert.mensaje}
                  </Alert>
                  <br></br>
                  <List sx={style}>
                    <ListItem>
                      <Grid container>
                        <Grid item xs={6} sm={6}>
                          <b style={{ marginRight: 50 }}>Fecha</b>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                          <span style={{ float: "right" }}>
                            <ListItemText primary={alert.date} />
                          </span>
                        </Grid>
                      </Grid>
                    </ListItem>
                    <Divider component="li" />
                    <ListItem>
                      <Grid container>
                        <Grid item xs={6} sm={6}>
                          <b style={{ marginRight: 50 }}>Referencia</b>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                          <span style={{ float: "right" }}>
                            <ListItemText primary={alert.reference} />
                          </span>
                        </Grid>
                      </Grid>
                    </ListItem>
                    <Divider component="li" />
                    <ListItem>
                      <Grid container>
                        <Grid item xs={6} sm={6}>
                          <b style={{ marginRight: 50 }}>Valor</b>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                          <span style={{ float: "right" }}>
                            <ListItemText primary={"$" + alert.price} />
                          </span>
                        </Grid>
                      </Grid>
                    </ListItem>
                    {alert.receipt && (
                      <>
                        <Divider component="li" />
                        <ListItem>
                          <Grid container>
                            <Grid item xs={6} sm={6}>
                              <b style={{ marginRight: 50 }}>Recibo</b>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                              <span style={{ float: "right" }}>
                                <ListItemText primary={alert.receipt} />
                              </span>
                            </Grid>
                          </Grid>
                        </ListItem>
                      </>
                    )}
                  </List>
                </Grid>
                <Grid item xs={12} sm={12} sx={{ paddingTop: 15 }}>
                  <center>
                    <ButtonStyle0 href="https://usamebpo.com/">
                      Salir de la ventana
                    </ButtonStyle0>
                  </center>
                </Grid>
              </>
            )}
            <Grid
              item
              xs={12}
              sm={6}
              sx={{
                display: info ? "block" : "none",
              }}
            >
              <Grid container>
                {valueRadio !== "otro" && (
                  <>
                    <Grid item xs={12} sm={12}>
                      <center>
                        <Box
                          component="img"
                          src="https://static.placetopay.com/placetopay-logo.svg"
                          alt="paymentsCompany"
                          sx={{ width: 180, m: "10px 0" }}
                        ></Box>
                      </center>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <center>
                        <Box
                          component="img"
                          src={typeCard}
                          alt="franquicias"
                          sx={{ width: 150, m: "2px 0" }}
                        ></Box>
                      </center>
                    </Grid>
                  </>
                )}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  sx={{ pt: valueRadio === "otro" ? 0 : 3 }}
                >
                  <center>
                    <FormControl>
                      <FormLabel
                        id="demo-row-radio-buttons-group-label"
                        sx={{ fontWeight: "bold", color: "#000" }}
                      >
                        Datos de facturación:
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={valueRadio}
                        onChange={handleChangeRadio}
                      >
                        <FormControlLabel
                          value="titular"
                          control={<Radio />}
                          label="Titular"
                          sx={{ color: "#000" }}
                        />
                        <FormControlLabel
                          value="otro"
                          control={<Radio />}
                          label="Otros datos"
                          sx={{ color: "#000" }}
                        />
                      </RadioGroup>
                    </FormControl>
                  </center>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  sx={{
                    pt: 2,
                    display: valueRadio === "otro" ? "block" : "none",
                  }}
                >
                  <Grid container className={classes.containerProfile}>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        name="allName"
                        value={values.allName}
                        error={values.errorAllName}
                        onChange={(event) =>
                          handleChange("allName", event.target.value)
                        }
                        fullWidth
                        label="Nombre completo"
                        margin="dense"
                        autoComplete="off"
                        size="small"
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <FormControl>
                        <FormLabel
                          id="demo-row-radio-buttons-group-label"
                          sx={{ color: "#000000" }}
                        >
                          Tipo de documento:
                        </FormLabel>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={radioDocument}
                          onChange={handleRadioDocument}
                        >
                          <FormControlLabel
                            value="CI"
                            control={<Radio />}
                            label="Cédula"
                            sx={{ color: "#000000" }}
                          />
                          <FormControlLabel
                            value="RUC"
                            control={<Radio />}
                            label="RUC"
                            sx={{ color: "#000000" }}
                          />
                          <FormControlLabel
                            value="PPN"
                            control={<Radio />}
                            label="Pasaporte"
                            sx={{ color: "#000000" }}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <TextField
                        name="documentId"
                        value={values.documentId}
                        error={values.errorDocumentId}
                        onChange={(event) =>
                          handleChange("documentId", event.target.value)
                        }
                        fullWidth
                        required
                        label="Nro. de documento"
                        margin="dense"
                        variant="outlined"
                        autoComplete="off"
                        inputProps={{
                          style: {
                            textAlign: "left",
                          },
                          maxLength: 13,
                        }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }}
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        name="emailFact"
                        value={values.emailFact}
                        error={values.errorEmailFact}
                        onChange={(event) =>
                          handleChange("emailFact", event.target.value)
                        }
                        fullWidth
                        label="Correo electrónico"
                        margin="dense"
                        autoComplete="off"
                        size="small"
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        name="addressFact"
                        value={values.addressFact}
                        error={values.errorAddressFact}
                        onChange={(event) =>
                          handleChange("addressFact", event.target.value)
                        }
                        fullWidth
                        label="Dirección"
                        margin="dense"
                        autoComplete="off"
                        size="small"
                        required
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <center>
                    <ButtonStyle0
                      type="submit"
                      onClick={createPay}
                      style={{ marginTop: 40 }}
                      disabled={disabledPay}
                    >
                      Pagar ${props.rows.productsJson[0].payTotal}
                    </ButtonStyle0>
                  </center>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}
